import React, { useState } from 'react'
import { apiurl } from '../../path'
import { BankofMaharashtraLogo256, Contact32, EmailS32, login_side_img, Loginimg, SingleUnifiedPortalLogo, SoftmateSystemsLogo, Time32, SingleUnifiedSystemLogo1, SingleUnifiedPortalLogo1 } from '../../public/LoginImages/importimages';
const ForgetPassword = () => {
  const [email, setEmail] = useState('');

  const handleResetPassword = async (e) => {
    console.log("called");
    
    e.preventDefault();
    try {
      let Forgettoken = await fetch(apiurl + '/ForgetPassword',
        {
          method: "POST",
          headers: ({ 'Content-Type': 'Application/json' }),
          body: JSON.stringify({ email: email })
        })
      Forgettoken = await Forgettoken.json()
      console.log("forgettoken", Forgettoken);

      if (Forgettoken.status === true) {
        alert('Link has been sent to email');
      } else {
        alert(Forgettoken.message || 'Not valid Email');
      }

    } catch (error) {
      console.error("Error in AdminLogin:", error);
    }
  };
  const isMobile = window.innerWidth <= 768
  return (
    <>
      <div style={{ height: '80vh' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', padding: '3px 20px', }}>
          <div><img src={SingleUnifiedPortalLogo1} alt="Portal Logo" style={{ width: '25rem', height: 'auto' }} />
          </div>
          {/* <div style={{ color: 'white', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <img src={Contact32} alt="Contact" style={{ width: '16px', height: '16px' }} />
              <p style={{ margin: 0 }}>02063151402</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <img src={EmailS32} alt="Email" style={{ width: '16px', height: '16px' }} />
              <p style={{ margin: 0 }}>helpdesk@mhrddsup.in</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <img src={Time32} alt="Time" style={{ width: '16px', height: '16px' }} />
              <p style={{ margin: 0 }}>
                सोम. ते शुक्र.! स १०:०० ते संध्या ६:००
              </p>
            </div>
          </div> */}
        </div>
        <div style={{
          backgroundImage: `url(${Loginimg})`, backgroundSize: "cover", backgroundPosition: "center", height: "88vh", width: "100%", position: "relative",
        }}>

          <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(255, 255, 255, 0.85)", borderRadius: "10px", boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)", }}>
            <form onSubmit={handleResetPassword} style={{ display: 'grid', justifyContent: 'center', width: '100%', maxWidth: '400px', padding: isMobile ? '0 20px' : '0', borderRadius: '10px', boxShadow: '2px 2px 6px 2px', backgroundColor: '#f4f7fe' }}>
              <h6 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', borderRadius: '10px 10px 0px 0px', padding: '10px', color: 'white' }}>Forgot Password</h6>
              <div className="card" style={{ width: "100%", backgroundColor: 'transparent', border: "none", padding: '20px', borderRadius: '12px', }}>
                <div className="card-body" style={{ display: 'grid', gap: '10px' }}>
                  <input
                    style={{ border: "none", borderRadius: "0", borderBottom: "2px solid" }}
                    type="email"
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className='form-control'
                  />
                  <button type='submit' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '12rem', height: '2.5rem', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', borderRadius: '11px', fontSize: '19px' }}>Send Reset Link</button>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p style={{ background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'none', }}><a href='/AdminLogin'><span style={{ width: '20px' }}>&larr;</span> Back To Sign In</a></p>
              </div>
            </form>
          </div>
          <footer style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 0, width: '100%', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', color: 'white', textAlign: 'center', padding: '10px 20px', fontSize: '14px', alignItems: 'center' }}>
            <div > <p style={{ margin: '0px' }}>
              Contents on this website are owned, updated, and managed by the Rural Development Department, Government of Maharashtra.<br />
              Site is technically designed, hosted, and maintained by <strong style={{ color: '#fff700' }}> Bank of Maharashtra.</strong>
              Site is technically designed, hosted, and maintained by <strong style={{ color: '#fff700' }}> Bank of Maharashtra.</strong>
            </p>
            </div><div style={{ display: 'flex', gap: '16px' }}>
              <img src={BankofMaharashtraLogo256} style={{ backgroundColor: 'white', height: 'auto' }} />
              {/* <img src={SoftmateSystemsLogo} style={{ width: '7.5rem', height: 'auto' }} /> */}
            </div>
          </footer>
        </div>
      </div>
    </>
  )
}

export default ForgetPassword